import { ReactComponent as CheckBoxIconUnstyled } from './check-box.svg'
const CheckBoxIcon = () => (
    <CheckBoxIconUnstyled style={{ overflow: 'visible' }} />
)
export default CheckBoxIcon
